import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IManagementGroup, IOrganization, IResponse } from '@interfaces/index';
import { HttpService } from '@ui-components/services';
import { ICreate } from 'projects/ui-components/src/interfaces/ICohort';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AppService } from '@ui-components/services';
import { IInventory } from 'projects/ui-components/src/interfaces/IOrganization';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {

  constructor(
    protected _http_service: HttpService,
    private app_service: AppService,
    private _snack_bar: MatSnackBar
  ) {}

  getOrgsById(org_id: number): Observable<IResponse<IOrganization[]>> {
    return this._http_service.post<IOrganization[]>('orgs/get-orgs-by-id', { org_id }).pipe(
      catchError((error) => {
        this.handleError('Failed to retrieve organizations.', error);
        return of({
          code: error.status || 500,
          data: [],
          message: error.message || 'Error fetching organizations'
        });
      })
    );
  }

  createOrganization(name: string, require_approval: boolean): Observable<IResponse<ICreate>> {
    return this.app_service.selectedManagementGroup$.pipe(
      switchMap<IManagementGroup | null, Observable<IResponse<ICreate>>>(selectedGroup => {
        const selectedOrgId = selectedGroup?.id || null;
        return this._http_service.post<ICreate>('orgs/create', {
          name,
          require_approval,
          org_id: selectedOrgId
        });
      }),
      catchError((error) => {
        this.handleError('Failed to create organization.', error);
        return of({
          code: error.status || 500,
          data: {} as ICreate,
          message: error.message || 'Error creating organization'
        });
      })
    );
  }

  updateOrganization(name: string, org_id: number, require_approval: boolean): Observable<IResponse<ICreate>> {
    return this._http_service.post<ICreate>('orgs/update', {
      name,
      org_id,
      require_approval
    }).pipe(
      catchError((error) => {
        this.handleError('Failed to update organization.', error);
        return of({
          code: error.status || 500,
          data: {} as ICreate,
          message: error.message || 'Error updating organization'
        });
      })
    );
  }

  private handleError(message: string, error: unknown): void {
    console.error(`${message}:`, error);
    let errorMessage = 'An error occurred';

    if (error instanceof Error) {
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      errorMessage = error;
    }

    this._snack_bar.open(message, 'Close', {
      duration: 5000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
      panelClass: 'lib-notification-error'
    });
  }

  inventory(assessment_id: number): Observable<IResponse<IInventory[]>> {
    return this._http_service.post('orgs/inventory', {
      assessment_id
    })
  };
}
